// extracted by mini-css-extract-plugin
var _1 = "ShareModalDrawerTextMessage-module__button___e3xW1";
var _2 = "ShareModalDrawerTextMessage-module__disabled___Pgy8S";
var _3 = "ShareModalDrawerTextMessage-module__form___QHjX1";
var _4 = "ShareModalDrawerTextMessage-module__loading___KA6MZ";
var _5 = "ShareModalDrawerTextMessage-module__phone___qKyzs";
export { _1 as "button", _2 as "disabled", _3 as "form", _4 as "loading", _5 as "phone" }
